var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasNote)?_c('v-badge',{attrs:{"color":"grey darken-1","inline":"","left":"","icon":"mdi-comment-outline"}},[_c('strong',[_vm._v(_vm._s(_vm.title))])]):_c('strong',[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }